import OptionListDialog from "@/components/Common/OptionListDialog/OptionListDialog.vue";
import LocationMap from "@/components/Common/LocationMap/LocationMap.vue";
import ImagePreview from "@/components/Common/ImagePreview/ImagePreview.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { getCoordinatesByAddress } from "@/helpers/commonHelper";
import {
  checkPlz,
  checkLat,
  checkLng
} from "@/configuration/formConfigurations";
import _ from "lodash";
import "./POIWIdgetEdit.scss";
import { getPoisForConnectionMapping } from "@/helpers/poiHelper";
import tinyColor from "tinycolor2";
import { mapOptionDialogConfig } from "@/configuration/formConfigurations";

const MAIN_DARK_GREY = "#444444";

export default {
  name: "POIWidgetEdit",
  props: ["editedItem", "dialog"],
  data: () => ({
    personalPictureInput: null,
    pois: [],
    step: 1,
    defineAllColors: false,
    position: 1,
    zoom: 17,
    btnDisable: true,
    type: "hex",
    hex: "#23454",
    baseColorPicker: false,
    lightColorPicker: false,
    darkColorPicker: false,
    itemLightColorPicker: false,
    itemDarkColorPicker: false,
    isValid: false,
    dragging: false,

    files: [],
    addUrls: [
      {
        line: ""
      }
    ],
    possibleViews: [
      { id: "list", title: "Kompakt" },
      { id: "cards", title: "Liste" },
      { id: "map", title: "Karte" }
    ],
    emphasizedFeatures: [
      { id: "", title: "--- keines ---" },
      { id: "59af08d34b85e801000d601f", title: "Bad Hindelang PLUS" },
      { id: "59af08e417f9ec01009b1616", title: "Oberstaufen PLUS" },
      { id: "59c368abb3b24b0100823946", title: "Oberstaufen PLUS Golf" }
    ],
    personalPicture: false
  }),
  methods: {
    checkPlz,
    checkLat,
    checkLng,
    async getCoordinates() {
      const res = await getCoordinatesByAddress(
        this.editedItem?.address,
        this.$refs.optionDialog,
        mapOptionDialogConfig
      );
      if (res?.status) this.editedItem.geo = res.geo;
      else if (!res?.status && res?.message) {
        this.$emit("error", res?.message);
      }
    },
    async getCoordinatesForPoi(poi) {
      const res = await getCoordinatesByAddress(
        poi?.address,
        /**
         * optionDialogPoi is declared in a for loop, so unfortunately it is an array.
         * There is currently no better posibillity, because we need the poi in the
         * updateGeoPosition method
         **/
        this.$refs.optionDialogPoi?.[0],
        mapOptionDialogConfig
      );
      if (res?.status) {
        poi.geo = res.geo;
      } else if (!res?.status && res?.message) {
        this.$emit("error", res?.message);
      }
    },
    updateGeoPosition(geo, item) {
      const { lat, lng } = geo;
      item.geo = { lat, lng };
    },
    removePersonalPicture() {
      this.personalPicture = "";
      this.editedItem.personalPicture = "";
      this.$refs.personalPictureInput.value = null;
    },
    removePoiPicture(index) {
      this.editedItem.myPois[index].dataUrl = "";
      this.editedItem.myPois[index].picture = "";
      this.$refs[`poiPictureInput-${index}`][0].value = null;
      this.$emit("reloadEditedItem");
    },
    async addPersonalPicture(e) {
      const file = e?.dataTransfer?.files ?? e;
      if (file) {
        this.personalPicture = await this.readFileUrl(file);
        this.editedItem.personalPicture = file;
      } else this.removePersonalPicture();
      this.dragging = false;
    },
    async addPoiPicture(e, index) {
      const file = e?.dataTransfer?.files ?? e;
      if (file) {
        this.editedItem.myPois[index].dataUrl = await this.readFileUrl(file);
        this.editedItem.myPois[index].picture = file;
        this.$emit("reloadEditedItem");
      } else {
        this.removePoiPicture(index);
      }
      this.dragging = false;
    },
    getPersonalPicture() {
      return this.personalPicture || this.editedItem.personalPicture;
    },

    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = ({ target }) => {
          if (target?.result) resolve(target.result);
          else reject("Unable to read File");
        };
        reader.readAsDataURL(file);
      });
    },

    addNewRow() {
      if (!Array.isArray(this.editedItem.allowedURLs))
        this.editedItem.allowedURLs = [];
      this.editedItem.allowedURLs.push("");
    },
    deleteRow(index) {
      /**
       * Needs to be done with splice. Otherwise the similar
       * items at different locations could be removed instead,
       * because the items are only strings and are not unique
       */
      this.editedItem.allowedURLs.splice(index, 1);
    },

    toggleColorPicker(key) {
      for (let i = 0; i < 5; i++) {
        const loopKey = `colorPicker${i}`;
        if (loopKey !== key) this[loopKey] = false;
      }
      this[key] = !this[key];
    },

    addNewPoi() {
      this.editedItem.myPois.push({
        title: "",
        description: "",
        picture: "",
        category: "",
        categoryType: "",
        address: {
          address: "",
          additionalAddress: "",
          zip: "",
          city: "",
          district: ""
        },
        geo: { lat: "", lng: "" },
        highlight: false,
        annotation: ""
      });
    },
    calculateColors() {
      if (this.editedItem?.output?.colors?.manualColor) return;
      const colors = tinyColor(this.selectedBaseColor)
        .monochromatic(19)
        .sort();

      this.selectedLightColor = colors[17].desaturate(30).toHexString();
      this.selectedDarkColor = colors[3].toHexString();
      this.selectedItemLightColor = tinyColor(this.selectedLightColor).isLight()
        ? MAIN_DARK_GREY
        : "white";
      this.selectedItemDarkColor = tinyColor(this.selectedDarkColor).isLight()
        ? MAIN_DARK_GREY
        : "white";
    },
    setCategoryGroupAndType(category, poi) {
      if (Array.isArray(category)) category = category[0];
      poi.category = category;
      poi.categoryGroup = this.categories.find(
        cat => cat._id === category
      )?.categoryGroup;
      poi.categoryType = this.categoryGroups.find(
        group => group._id === poi.categoryGroup
      )?.categoryType;
    }
  },
  computed: {
    formTitle() {
      if (this.editedItem.title)
        return `POI Widget für: "${this.editedItem.title}"`;
      else return "POI Widget erstellen";
    },

    color: {
      get() {
        return this[this.type];
      },
      set(v) {
        this[this.type] = v;
      }
    },
    selectedBaseColor: {
      get() {
        if (typeof this.editedItem?.output?.colors?.baseColor === "string")
          return this.editedItem?.output?.colors?.baseColor;
      },
      set(val) {
        this.editedItem.output.colors.baseColor = val;
        this.calculateColors();
      }
    },
    selectedLightColor: {
      get() {
        if (typeof this.editedItem?.output?.colors?.lightColor === "string")
          return this.editedItem?.output?.colors?.lightColor;
      },
      set(val) {
        this.editedItem.output.colors.lightColor = val;
      }
    },
    selectedDarkColor: {
      get() {
        if (typeof this.editedItem?.output?.colors?.darkColor === "string")
          return this.editedItem?.output?.colors?.darkColor;
      },
      set(val) {
        this.editedItem.output.colors.darkColor = val;
      }
    },
    selectedItemLightColor: {
      get() {
        if (typeof this.editedItem?.output?.colors?.hlLightColor === "string")
          return this.editedItem?.output?.colors?.hlLightColor;
      },
      set(val) {
        this.editedItem.output.colors.hlLightColor = val;
      }
    },
    selectedItemDarkColor: {
      get() {
        if (typeof this.editedItem?.output?.colors?.hlDarkColor === "string")
          return this.editedItem?.output?.colors?.hlDarkColor;
      },
      set(val) {
        this.editedItem.output.colors.hlDarkColor = val;
      }
    },
    categoryGroups() {
      return this.$store.state.categoryGroups.filter(
        group =>
          !!this.categoryTypes.find(type => type._id === group.categoryType)
            ?._id
      );
    },
    categoryTypes() {
      return this.$store.state.categoryTypes;
    },
    featureGroups() {
      return _.sortBy(this.$store.state.featureGroups, "title");
    },
    features() {
      return _.sortBy(
        _.flatten(this.featureGroups.map(fg => fg.features)),
        "title"
      );
    },
    categories() {
      return _.flatten(this.categoryGroups.map(ct => ct.categories));
    },
    annotations: {
      get() {
        return Object.keys(this.editedItem?.annotations ?? {});
      },
      set(val) {
        const id = val.pop();
        this.editedItem.annotations[id] = {
          comment: "",
          highlight: false,
          _id: id
        };
        this.editedItem.annotations = { ...this.editedItem.annotations };
      }
    },
    poiKeyTitleList() {
      const poiKeyTitleList = {};
      this.pois.forEach(poi => {
        poiKeyTitleList[poi._id] = poi.title;
      });
      return poiKeyTitleList;
    }
  },
  async mounted() {
    await this.$store.dispatch("getFeatureGroupsForPois");
    await this.$store.dispatch("getCategoryGroups");
    await this.$store.dispatch("getCategoryTypes");
    this.pois = await getPoisForConnectionMapping(
      this.$store.state.selectedPrincipal.id
    );
  },
  components: {
    OptionListDialog,
    LocationMap,
    ImagePreview,
    TreeViewSelection,
    InfoDialog
  }
};
